import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router";
import "./style.css";
import Logo from '../../assets/images/notifyi-logo-dark.png'


import AdmissionApi, { acz } from "../../Services/AdmissionApi";

import LoginForm from "./LoginForm";
import RegistraionForm from "./RegistraionForm";
import OtpForm from "./OtpForm";
import ForgotPasswordForm from "./ForgotPasswordForm";


class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      id: "signin-link",
      redirectToReferrer: false,
      reset_user: "",
      otp: "",
      phone: "",
      school_code: "",
      student_limit: "",
      JoinedStudent: "",
      remainingStudent: 0,
      resetPassword: false,
      category: false,
      userId: '',
      fName: '',
      lName: '',
      email: '',
      gender: '',
      date_of_birth: '',
      subjects: '',
      father_name: '',
    };

    this.showSelectedId = this.showSelectedId.bind(this);
    this.setData = this.setData.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.changeToLogin = this.changeToLogin.bind(this);
    this.setDataWithOtp = this.setDataWithOtp.bind(this);
    this.setDataWithoutOtp = this.setDataWithoutOtp.bind(this);

    this.admissionsService = new AdmissionApi();
  }

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  componentDidMount() {
    if (this.props.location.pathname == "/signIn/resetpassword") {
      this.setState({
        id: "forgot-password-link",
        resetPassword: true,
        reset_user: this.props.location.query.email,
      });
      history.pushState(null, "", location.href.split("?")[0]);
    }

    // Setting static client and app IDs
    const whoIsLogin = window.location.pathname.slice(1).split('/')[0]
    let obj
    if (whoIsLogin === 'admin') {
      obj = { clientId: 1, appId: 'qRQ3v5bmXC0p2rCPpZFaGUtvuCXeZn' } // admin
    } else {
      obj = { ...acz }
    }

    this.admissionsService.setObj(obj);
  }

  showSelectedId(event) {
    this.setState({ id: event.target.id });
  }

  setData(user, id) {
    this.setState({ username: user, id: id });
  }

  formatSubmitDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  setDataWithOtp(data, id) {
    this.setState({
      username: data.type,
      id: id,
      otp: data.otp,
      phone: data.destination_mobile_no,
      category: data.category,
      userId: data.user_id,
      school_code: data.school_code,
      fName: data.first_name,
      lName: data.last_name,
      email: data.email,
      gender: data.gender,
      date_of_birth: this.formatSubmitDate(data.date_of_birth),
      subjects: data.subjects,
      father_name: data.father_name,
      isInactive: data.isInactive ? true : false,
      approval_status:"approved"
    });
  }

  setDataWithoutOtp(data, id) {
    this.setState({ username: data.type });
    if (data.type == 1 || data.type == 2) {
      localStorage.setItem("isAdminLogin", true);
      this.context.router.push("/admin");
    } else {
      localStorage.setItem("isLogin", "1");
      this.context.router.push("/dashboard");
    }
  }

  handleLogin(event) {
    if (this.state.username == 1 || this.state.username == 2) {
      localStorage.setItem("isAdminLogin", true);
      this.context.router.push("/admin");
    } else {
      localStorage.setItem("isLogin", "1");
      this.context.router.push("/dashboard");
    }
  }

  changeToLogin(id) {
    this.setState({ id: id });
  }

  render() {
    let isLogin = localStorage.getItem("isLogin");
    const type = isLogin;
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }

    return (
      <div className="auth__container">
        <div className="auth__bg d-none d-lg-block"></div>
        <div className="auth__content p-3 p-lg-0">
          <Link to="/">
            <figure  className="auth__logo">
              <img src={Logo} alt="logo" />
            </figure>
          </Link>
          <form>
            <div className="auth__form">
              {this.state.id === "signin-link" && (
                <div id="signin">
                  <LoginForm
                    changeForm={this.showSelectedId}
                    sendData={this.setDataWithoutOtp}
                    sendDataWithOtp={this.setDataWithOtp}
                  ></LoginForm>
                </div>
              )}
              {this.state.id === "signup-link" && (
                <div id="signup">
                  <RegistraionForm
                    changeForm={this.showSelectedId}
                    sendData={this.setDataWithOtp}
                    sendDataWithOtp={this.setDataWithOtp}
                  ></RegistraionForm>
                </div>
              )}
              {this.state.id === "forgot-password-link" && (
                <div id="forgot-password">
                  <ForgotPasswordForm
                    changeToLogin={this.changeToLogin}
                    reset={this.state.resetPassword}
                    userName={this.state.reset_user}
                    changeForm={this.showSelectedId}
                  ></ForgotPasswordForm>
                </div>
              )}
              {this.state.id === "otp-link" && (
                <div id="otp">
                  <OtpForm
                    proceedLogin={this.handleLogin}
                    otp={this.state.otp}
                    phone={this.state.phone}
                    changeForm={this.showSelectedId}
                    data={this.state}
                  ></OtpForm>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default SignIn;



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/index.js
 **/